var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e0"
    },
    d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d9d7ca"
    },
    points: "37.5,0.151 37.5,12 49.349,12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ce3c3b",
      fillOpacity: 1
    },
    d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "M28.5,24v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2V8h-2V6h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2 h-4v5c0,2.757,2.243,5,5,5s5-2.243,5-5v-5H28.5z M30.5,29c0,1.654-1.346,3-3,3s-3-1.346-3-3v-3h6V29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "M26.5,30h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S25.948,30,26.5,30z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99499753,1.0050276)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "13.81912994px",
      fontFamily: "Allerta",
      InkscapeFontSpecification: "Allerta",
      fill: "#fff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 20.219066,52.709572 -1.875839,-3.60323 q -0.04049,0 -0.107962,0.01349 -0.06748,0 -0.215924,0 -0.134952,0 -0.431848,0 -0.2834,0 -0.782724,0 l 0,3.589735 -1.619429,0 0,-9.945995 2.860992,0 q 0.634276,0 1.255057,0.202429 0.620782,0.202428 1.10661,0.607286 0.499324,0.404857 0.79622,0.985152 0.31039,0.566801 0.31039,1.282049 0,1.079619 -0.499324,1.835353 -0.499324,0.755733 -1.349524,1.120105 l 2.267201,3.913621 -1.713896,0 z m -3.414297,-4.777317 1.470982,0 q 0.296895,0 0.593791,-0.09447 0.296895,-0.107962 0.539809,-0.337381 0.242915,-0.22942 0.391362,-0.634277 0.148448,-0.418352 0.148448,-1.025638 0,-0.242915 -0.06748,-0.553305 -0.06748,-0.323886 -0.2834,-0.607286 -0.202429,-0.296896 -0.580296,-0.485829 -0.377867,-0.202429 -0.998648,-0.202429 l -1.214572,0 0,3.940611 z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23.72783,52.709572 3.481773,-9.9325 1.605934,0 3.454782,9.9325 -1.67341,0 -0.715248,-2.064773 -3.738183,0 -0.728743,2.064773 -1.686905,0 z m 2.793515,-3.157887 2.968954,0 -1.470982,-4.291488 -1.497972,4.291488 z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.382312,52.709572 -1.875839,-3.60323 q -0.04049,0 -0.107962,0.01349 -0.06748,0 -0.215924,0 -0.134952,0 -0.431847,0 -0.283401,0 -0.782725,0 l 0,3.589735 -1.619429,0 0,-9.945995 2.860992,0 q 0.634276,0 1.255058,0.202429 0.620781,0.202428 1.10661,0.607286 0.499324,0.404857 0.796219,0.985152 0.310391,0.566801 0.310391,1.282049 0,1.079619 -0.499324,1.835353 -0.499324,0.755733 -1.349525,1.120105 l 2.267201,3.913621 -1.713896,0 z m -3.414297,-4.777317 1.470982,0 q 0.296895,0 0.593791,-0.09447 0.296895,-0.107962 0.539809,-0.337381 0.242915,-0.22942 0.391363,-0.634277 0.148447,-0.418352 0.148447,-1.025638 0,-0.242915 -0.06748,-0.553305 -0.06748,-0.323886 -0.2834,-0.607286 -0.202429,-0.296896 -0.580296,-0.485829 -0.377866,-0.202429 -0.998648,-0.202429 l -1.214572,0 0,3.940611 z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRar);
export default __webpack_public_path__ + "static/media/rar.b781305f772d1f9e7c6f005e09dccba1.svg";
export { ForwardRef as ReactComponent };